export const DEFAULT_MAX_FILE_SIZE = 20 * 1024 * 1024; // 20 MB

export const DEFAULT_MAX_NUMBER_OF_FILES = 1;

export const VALID_MIME_TYPES = new Set([
  '*/*',
  'application/*',
  'application/json',
  'application/pdf',
  'application/xml',
  'application/zip',
  'audio/*',
  'image/*',
  'image/gif',
  'image/jpeg',
  'image/png',
  'image/webp',
  'message/*',
  'model/*',
  'multipart/*',
  'text/*',
  'text/csv',
  'text/html',
  'text/plain',
  'video/*',
]);

export const VALID_TOP_LEVEL_TYPES = new Set([
  'application',
  'audio',
  'image',
  'message',
  'model',
  'multipart',
  'text',
  'video',
]);
